import type { DTOApplicationFormReturn } from "types/Card";

/**
 * GIWL states where coverage replacement is not available: the Yes/No option is
 * read-only and hard-coded to "No". All other states allow the user to choose.
 */
export const GIWL_COVERAGE_REPLACEMENT_READONLY_STATES = ["FL", "GA", "MI", "NV", "WY"];

/**
 * Creates replacement data payload for Redux store
 */
export const createReplacementPayload = (coverageReplacement: any) => {
    if (!coverageReplacement) {
        return null;
    }

    return {
        replacementIndicator: coverageReplacement.isReplacing,
        replacementCompany: coverageReplacement.isReplacing ? coverageReplacement.replacementCompany : undefined,
        replacementAccount: coverageReplacement.isReplacing ? coverageReplacement.replacementAccount : undefined,
    };
};

/**
 * Restores coverage replacement form data from Redux
 */
export const restoreFormData = (coverageReplacementData: any, setValue: DTOApplicationFormReturn["setValue"]) => {
    if (!coverageReplacementData) {
        return;
    }

    setValue("coverageReplacement.isReplacing", coverageReplacementData?.replacementIndicator ?? null);
    setValue("coverageReplacement.replacementCompany", coverageReplacementData?.replacementCompany || "");
    setValue("coverageReplacement.replacementAccount", coverageReplacementData?.replacementAccount || "");
};

/**
 * Handles radio button changes for replacement indicator
 */
export const handleReplacementChange = async (
    value: boolean,
    setValue: DTOApplicationFormReturn["setValue"],
    trigger: DTOApplicationFormReturn["trigger"]
) => {
    setValue("coverageReplacement.isReplacing", value);
    await trigger("coverageReplacement.isReplacing");

    if (!value) {
        setValue("coverageReplacement.replacementCompany", "");
        setValue("coverageReplacement.replacementAccount", "");
    }
};

/**
 * Extracts replacement values from form
 */
export const extractReplacementValues = (formData: any) => {
    return {
        replacementIndicator: formData.isReplacing,
        replacementCompany: formData.isReplacing ? formData.replacementCompany : undefined,
        replacementAccount: formData.isReplacing ? formData.replacementAccount : undefined,
    };
};
